/* eslint no-param-reassign: [0] */

import { get, isArray, clone, includes, each, without } from 'lodash';

function paramValueIsNotEqualTo(params, key, value) {
  const currentValue = params[key];
  return currentValue &&
    currentValue !== value &&
    !includes(currentValue, value);
}

function paramsOverriddenByNewValues(params, objectWithNewValues) {
  return { ...params, ...objectWithNewValues };
}

function paramsWithoutKeys(params, keys, newParams = null) {
  newParams = newParams || ({ ...params });
  keys.forEach((key) => delete newParams[key]);
  return newParams;
}

export default {
  batch(params, actionToParamsMap) {
    let newParams = { ...params };

    if (actionToParamsMap.set) {
      newParams = paramsOverriddenByNewValues(params, actionToParamsMap.set);
    }

    if (actionToParamsMap.unset) {
      newParams = paramsWithoutKeys(params, actionToParamsMap.unset, newParams);
    }

    if (!get(actionToParamsMap, 'set.page')) {
      delete newParams.page;
    }

    return newParams;
  },

  setAll(params) {
    return params;
  },

  set(params, obj) {
    const newParams = paramsOverriddenByNewValues(params, obj);

    if (!obj.page) {
      delete newParams.page;
    }

    return newParams;
  },

  unset(params, keys) {
    const newParams = paramsWithoutKeys(params, keys);
    delete newParams.page;
    return newParams;
  },

  unmergeArrayParams(params, obj) {
    // removes a value from an array of params
    // if the set is empty, it will remove the key entirely
    //
    // params.condition == ['new', 'used']
    // handleArrayParamsUnmerge({ condition: 'new' }) => this.params.condition == ['used']
    // handleArrayParamsUnmerge({ condition: 'used' }) => this.params.condition == undefined

    const newParams = clone(params);
    each(obj, (value, key) => {
      const currentValue = newParams[key];
      const currentValueStr = (currentValue === undefined ? '' : currentValue).toString();
      const valueStr = (value === undefined ? '' : value).toString();
      if (isArray(currentValue)) {
        newParams[key] = without(currentValue, value);
      } else if (currentValueStr === valueStr) {
        delete newParams[key];
      }
    });

    delete newParams.page;

    return newParams;
  },

  mergeArrayParams(params, obj) {
    // if param does not already exist, will add it to params
    // if param already has a value, will convert query param to array
    //
    // params.condition == undefined
    // handleArrayParamsMerge({ foo: 'bar' }) => this.params.foo == 'bar'
    // handleArrayParamsMerge({ foo: 'buz' }) => this.params.foo == ['bar', 'buz']

    const newParams = clone(params);
    each(obj, (value, key) => {
      if (paramValueIsNotEqualTo(params, key, value)) {
        let currentValue = newParams[key];
        if (!isArray(currentValue)) {
          currentValue = [currentValue];
        }
        newParams[key] = currentValue.concat(value);
      } else {
        newParams[key] = value;
      }
    });

    delete newParams.page;

    return newParams;
  },
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/params_builder.js